import React, { useEffect, useState } from 'react';
import { Table, Button, Space, Tooltip, Form, Popconfirm, Menu, Dropdown, Select, Tag } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, DeleteFilled, EllipsisOutlined, EyeOutlined, PlusOutlined, StopOutlined } from '@ant-design/icons';
import "../Pages/CSS/DonnesBases.css";
import { GestionPretsService } from '../Services/GestionPretsService';
import NouveauPretsModal from './Modal_Doc/NouveauPretsModal';
import { GestionPaieService } from '../Services/GestionPaieService';
import dayjs from "dayjs";
import ArretPretModal from './Modal_Doc/ArretPretModal';
import { JournalCentralService } from '../Services/JournalCentralService';

const Option = Select
const GestionPrets = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [typePrets, setTypePrets] = useState([]);
  const [salaries, setSalaries] = useState([]);
  const [rubriques, setRubriques] = useState([]);
  const [tableData, setTableData] = useState([]);
   const [compteGenData, setCompteGenData] = useState([]);
  const [currentEmployee, setCurrentEmployee] = useState(null);
  const [isArretModalVisible, setIsArretModalVisible] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedMatricule, setSelectedMatricule] = useState("All");
  const [currentPretDetails, setCurrentPretDetails] = useState({});
const [pageSize, setPageSize] = useState(10)
  const [form] = Form.useForm();
 
  const userProfil = localStorage.getItem("profil");
  const gestionPaieService = new GestionPaieService();
  const gestionPretService = new GestionPretsService();
   const journalCentralService = new JournalCentralService()

  const fetchData = async () => {
    try {
      const data = await gestionPretService.getAllTypePret();
      setTableData(data);
      setFilteredData(data); 
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchSalaries(); // Charger les salariés au démarrage
  }, []);
  const fetchSalaries = async () => {
    try {
      const response = await gestionPaieService.getAllSalaries();
      setSalaries(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };
  
  const handleFilterChange = (value) => {
    setSelectedMatricule(value); // Mettre à jour le matricule sélectionné
  };

  // Utiliser useEffect pour appliquer le filtre lorsque selectedMatricule change
  useEffect(() => {
    if (selectedMatricule === null || selectedMatricule === "All") {
      // Si "All" est sélectionné ou si aucun matricule n'est sélectionné, afficher toutes les données
      setFilteredData(tableData);
    } else {
      // Filtrer les données du tableau par matricule
      const filtered = tableData.filter((item) => item.matrisal === selectedMatricule);
      setFilteredData(filtered);
    }
  }, [selectedMatricule, tableData]);


  const fetchTypePrets = async () => {
    try {
      const response = await gestionPaieService.getAllTypePrets();
      setTypePrets(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };

  const fetchRubrique = async () => {
    try {
      const response = await gestionPaieService.getAllRubriques();
      setRubriques(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };
  const handleArretModalOk = async (values) => {
    try {
      // Créer le payload avec toutes les données de la ligne sélectionnée
      const payload = {
        ...currentPretDetails,  // Ajouter toutes les données de la ligne sélectionnée
        motif_arret_pret: values.motif_arret_pret,  // Motif sélectionné
        date_arret_pret: values.date_arret_pret.format("YYYY-MM-DD"),  // Date d'arrêt
        observation: values.observation,  // Observation
        nb_report_ech:values.nb_report_ech || 1
      };
  
      // Appeler la méthode du service pour arrêter le prêt avec le payload
      await gestionPretService.putpret(payload);
  
      // Fermer le modal et actualiser les données
      setIsArretModalVisible(false);
      fetchData();  // Actualiser les données dans la table
      form.resetFields();
  
    } catch (error) {
      console.error('Erreur lors de l\'arrêt du prêt :', error);
      // Gérer les erreurs ici, comme afficher une notification
    }
  };
  
  
  
  const handleArretPret = (record) => {
    // Stocker toutes les informations de la ligne sélectionnée dans currentPretDetails
    setCurrentEmployee(record);  // Information de l'employé associée
    setCurrentPretDetails(record);  // Toute la ligne du prêt
    setIsArretModalVisible(true);  // Ouvrir le modal
  };
  
 

  const handleArretModalCancel = () => {
    setIsArretModalVisible(false);
    form.resetFields();
  };

  const fetchListAll = async () => {
    try {
      const data = await journalCentralService.getPlanCompta();
      setCompteGenData(data);
    } catch (error) {
      console.log("Erreur lors de la récupération des adhérents:", error);
    }
  };
  const showModal = (employee) => {
    setCurrentEmployee(employee);
    setIsModalVisible(true);
    fetchSalaries();
    fetchListAll();
    fetchTypePrets();
    fetchRubrique();
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setCurrentEmployee(null);
    fetchData();
    form.resetFields();
  };

  const handleDelete = async (code) => {
    try {
      await gestionPretService.deletePret(code);
      await fetchData();
    } catch (error) {
      console.error('Erreur lors de la suppression :', error);
    }
  };

  const formatNumberSeparator = (number) => {
    return number.toLocaleString(); // Utilisez cette fonction pour formater les nombres
  };
/* 
  const menu = (record) => (
    <Menu>
      <Menu.Item key="1" icon={<EyeOutlined style={{ color: 'green' }} />} onClick={() => showModal(record)}>
        Voir
      </Menu.Item>
      <Menu.Item key="2" icon={<DeleteFilled style={{ color: 'red' }} />}>
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cet élément?"
          onConfirm={() => handleDelete(record.code)}
          okText="Oui"
          cancelText="Non"
        >
          Supprimer
        </Popconfirm>
      </Menu.Item>
      <Menu.Item key="3" icon={<CloseCircleOutlined style={{ color: 'orange' }} />} onClick={() => handleArretPret(record, { pret: record.libelle, montantPret: record.montant_pret, montantRestant: record.montant_restant,code:record.code })}>
        Arrêt d'un prêt
      </Menu.Item>
    </Menu>
  ); */
  const menu = (record) => (
    <Menu>
      {/* Action Voir : Toujours visible */}
      <Menu.Item key="1" icon={<EyeOutlined style={{ color: 'green' }} />} onClick={() => showModal(record)}>
        Voir
      </Menu.Item>
  
      {/* Action Supprimer : Visible uniquement si l'état est 'Pending' ou 'Stopped' ET duree_pret === nb_mois_restant */}
      {(record.etat === 'Pending' || record.etat === 'Stopped') && record.duree_pret === record.nb_mois_restant && (
        <Menu.Item key="2" icon={<DeleteFilled style={{ color: 'red' }} />}>
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer cet élément?"
            onConfirm={() => handleDelete(record.code)}
            okText="Oui"
            cancelText="Non"
          >
            Supprimer
          </Popconfirm>
        </Menu.Item>
      )}
  
      {/* Action Arrêt Prêt : Visible uniquement si l'état est 'Pending' */}
      {record.etat === 'Pending' && (
        <Menu.Item key="3" icon={<CloseCircleOutlined style={{ color: 'orange' }} />} onClick={() => handleArretPret(record)}>
          Arrêt d'un prêt
        </Menu.Item>
      )}
    </Menu>
  );
  
 /*  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      align: "center",
    },
    {
      title: 'Type',
      dataIndex: 'libelle',
      key: 'libelle',
    },
    {
      title: 'Date Prêt',
      dataIndex: 'date_pret',
      key: 'date_pret',
      align: "center",
      render: (text) => dayjs(text).format("DD/MM/YYYY"),
    },
    {
      title: 'Matricule',
      dataIndex: 'matrisal',
      key: 'matrisal',
      align: "center",
    },
    {
      title: 'Prénom',
      dataIndex: 'prenoms',
      key: 'prenoms',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "5px",
          }}
        >Montant Prêt</div>
      ),
      dataIndex: 'montant_pret',
      key: 'montant_pret',
      align: "right",
      render: (text) => <strong style={{ paddingRight: "5px" }}>{formatNumberSeparator(text)}</strong>,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "5px",
          }}
        >Montant/Echéance</div>
      ),
      dataIndex: 'montant_ech',
      key: 'montant_ech',
      align: "right",
      render: (text) => <strong style={{ paddingRight: "5px" }}>{formatNumberSeparator(text)}</strong>,
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "5px",
          }}
        >Montant Restant</div>
      ),
      dataIndex: 'capital_du',
      key: 'capital_du',
      align: "right",
      render: (text) => <strong style={{ paddingRight: "5px" }}>{formatNumberSeparator(text)}</strong>,
    },
    {
      title: 'Date Prem. Éch',
      dataIndex: 'date_prem_ech',
      key: 'date_prem_ech',
      align: "center",
      render: (text) => (text? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: 'Date Proch. Éch',
      dataIndex: 'prochain_echeance',
      key: 'prochain_echeance',
      align: "center",
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: 'Durée',
      dataIndex: 'duree_pret',
      key: 'duree_pret',
      align: "center",
    },
    {
      title: 'Nbr Éch Restant',
      dataIndex: 'nb_mois_restant',
      key: 'nb_mois_restant',
      align: "center",
    },
    {
      title: 'État',
      dataIndex: 'etat',
      key: 'etat',
      align: 'center',
      render: (text, record) => {
        if (record.etat === "Pending") {
          return (
            <Tooltip title="En Cours">
              <Tag color="#FFA500">En Cours</Tag> 
            </Tooltip>
          );
        } else if (record.etat === "End") {
          return (
            <Tooltip title="Terminé">
              <Tag color="#008000">Soldé</Tag> 
            </Tooltip>
          );
        } else if (record.etat === "Stopped") {
          return (
            <Tooltip title="Arrêté">
              <Tag color="#FF0000">Arrêté</Tag> 
            </Tooltip>
          );
        } else if (record.etat === "Report") {
          return (
            <Tooltip title="Reporté">
              <Tag color="#FFD700">Reporté</Tag>
            </Tooltip>
          );
        }
        return null;
      }
    },
    
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' ? [
      {
        title: (
          <div
            style={{
              backgroundColor: "#010f1c",
              color: "white",
              padding: "1px",
            }}
          ></div>
        ),
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        fixed: 'right',
      
        render: (text, record) => (
          <Dropdown overlay={menu(record)} trigger={['click']}>
            <EllipsisOutlined style={{ fontSize: '24px', cursor: 'pointer', transform: 'rotate(90deg)' }} />
          </Dropdown>
        ),
      },
    ] : []),
  ]; */

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      align: "center",
      sorter: (a, b) => a.code.localeCompare(b.code),
    },
    {
      title: 'Type',
      dataIndex: 'libelle',
      key: 'libelle',
      sorter: (a, b) => a.libelle.localeCompare(b.libelle),
    },
    {
      title: 'Date Prêt',
      dataIndex: 'date_pret',
      key: 'date_pret',
      align: "center",
      sorter: (a, b) => dayjs(a.date_pret).unix() - dayjs(b.date_pret).unix(),
      render: (text) => dayjs(text).format("DD/MM/YYYY"),
    },
    {
      title: 'Matricule',
      dataIndex: 'matrisal',
      key: 'matrisal',
      align: "center",
      sorter: (a, b) => a.matrisal.localeCompare(b.matrisal),
    },
    {
      title: 'Prénom',
      dataIndex: 'prenoms',
      key: 'prenoms',
      sorter: (a, b) => a.prenoms.localeCompare(b.prenoms),
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
      sorter: (a, b) => a.nom.localeCompare(b.nom),
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", padding: "5px" }}>
          Montant Prêt
        </div>
      ),
      dataIndex: 'montant_pret',
      key: 'montant_pret',
      align: "right",
      sorter: (a, b) => a.montant_pret - b.montant_pret,
      render: (text) => <strong style={{ paddingRight: "5px" }}>{formatNumberSeparator(text)}</strong>,
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", padding: "5px" }}>
          Montant/Echéance
        </div>
      ),
      dataIndex: 'montant_ech',
      key: 'montant_ech',
      align: "right",
      sorter: (a, b) => a.montant_ech - b.montant_ech,
      render: (text) => <strong style={{ paddingRight: "5px" }}>{formatNumberSeparator(text)}</strong>,
    },
    {
      title: (
        <div style={{ backgroundColor: "#010f1c", color: "white", padding: "5px" }}>
          Montant Restant
        </div>
      ),
      dataIndex: 'capital_du',
      key: 'capital_du',
      align: "right",
      sorter: (a, b) => a.capital_du - b.capital_du,
      render: (text) => <strong style={{ paddingRight: "5px" }}>{formatNumberSeparator(text)}</strong>,
    },
    {
      title: 'Date Prem. Éch',
      dataIndex: 'date_prem_ech',
      key: 'date_prem_ech',
      align: "center",
      sorter: (a, b) => dayjs(a.date_prem_ech).unix() - dayjs(b.date_prem_ech).unix(),
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: 'Date Proch. Éch',
      dataIndex: 'prochain_echeance',
      key: 'prochain_echeance',
      align: "center",
      sorter: (a, b) => dayjs(a.prochain_echeance).unix() - dayjs(b.prochain_echeance).unix(),
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    },
    {
      title: 'Durée',
      dataIndex: 'duree_pret',
      key: 'duree_pret',
      align: "center",
      sorter: (a, b) => a.duree_pret - b.duree_pret,
    },
    {
      title: 'Nbr Éch Restant',
      dataIndex: 'nb_mois_restant',
      key: 'nb_mois_restant',
      align: "center",
      sorter: (a, b) => a.nb_mois_restant - b.nb_mois_restant,
    },
    {
      title: 'État',
      dataIndex: 'etat',
      key: 'etat',
      align: 'center',
      sorter: (a, b) => a.etat.localeCompare(b.etat),
      render: (text, record) => {
        const stateColors = {
          Pending: "#FFA500", // Orange
          End: "#008000", // Vert
          Stopped: "#FF0000", // Rouge
          Report: "#FFD700", // Jaune doré
        };
        return (
          <Tooltip title={record.etat}>
            <Tag color={stateColors[record.etat] || "gray"}>{text}</Tag>
          </Tooltip>
        );
      },
    },
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5'
      ? [
          {
            title: (
              <div style={{ backgroundColor: "#010f1c", color: "white", padding: "1px" }}></div>
            ),
            dataIndex: 'actions',
            key: 'actions',
            align: 'center',
            fixed: 'right',
            render: (text, record) => (
              <Dropdown overlay={menu(record)} trigger={['click']}>
                <EllipsisOutlined
                  style={{ fontSize: '24px', cursor: 'pointer', transform: 'rotate(90deg)' }}
                />
              </Dropdown>
            ),
          },
        ]
      : []),
  ];
  

  return (
    <div>
       <Space style={{ marginBottom: 16, float: 'left' }}>
       <Select
          style={{ width: 200 }}
          defaultValue="All"  // Définir "Tous les salariés" comme valeur par défaut
          onChange={handleFilterChange}
          allowClear
          showSearch
          filterOption={(input, option) =>
            option.children.toLowerCase().includes(input.toLowerCase())
          }
        >
          {/* Option pour afficher tous les salariés */}
          <Option key="all" value="All">Tous les salariés</Option>

          {/* Options pour chaque salarié */}
          {salaries.map((salary) => (
            <Option key={salary.matricule} value={salary.matricule}>
             
             {`${salary.matricule} - ${salary.prenoms} ${salary.nom}`}
            </Option>
          ))}
        </Select>
      </Space>
      <Space style={{ marginBottom: 16, float: 'right' }}>
        {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
          <Button className='buttonExport' icon={<PlusOutlined />} onClick={() => showModal(null)}>Nouveau prêts</Button>
        )}
        <Button className='buttonRefresh' onClick={fetchData}>Actualiser</Button>
      </Space>
      <Table
        columns={columns}
        showSorterTooltip={false}
        dataSource={filteredData.map((item, index) => ({ ...item, key: index }))}
        scroll={{ x: true }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header2-table"
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
      <NouveauPretsModal
        isVisible={isModalVisible}
        onClose={handleModalClose}
        employee={currentEmployee}
        salaries={salaries}
        compteGenData={compteGenData}
        typePrets={typePrets}
        rubriques={rubriques}
        form={form}
      />
      <ArretPretModal
  visible={isArretModalVisible}
  onCancel={handleArretModalCancel}
  onOk={handleArretModalOk}
  pretDetails={currentPretDetails}  // Passer les détails du prêt ici
/>

    </div>
  );
}

export default GestionPrets;
